import VimeoPlayer from "@vimeo/player"
export const VimeoApi = (function () {

    class Player extends EventTarget{
        constructor(container, player, options) {
            super()
            
            this.container = container
            this.videoPlayer = player || container
            this.videoID = this.videoPlayer.dataset.videoId || null
            this.player = null
            this.playerReady = false
            this.events = []

            this.options = Object.assign({
                autoplay: false,
                background: false,
                muted: this.container.dataset.muted === "1",
                controls: this.container.dataset.controls === "1",
                playsinline: this.container.dataset.playsinline === "1"
            }, {
               ...options 
            })
            this._init()
        }

        _init() {
            this.createEvents()
            this.callApi()
        }

        createEvents() {
            this.events['loaded'] = new CustomEvent('loaded', {
                bubbles: true,
                detail: {
                    getValue: ()  => this.videoPlayer
                }
            })
            this.events['play'] = new CustomEvent('play', {bubbles: true})
            this.events['pause'] = new CustomEvent('pause', {bubbles: true})
            this.events['ended'] = new CustomEvent('ended', {bubbles: true})
        }

        async callApi() {
            await this.createPlayer()
            this.playerReady = true
            this.addPlayerListeners()
            this.dispatchEvent(this.events['loaded'])
        }

        createPlayer() {

            this.player = new VimeoPlayer(this.videoPlayer, {
                height: '100%',
                width: '100%',
                playsinline: this.options.playsinline,
                responsive: true,
                controls: this.options.controls,
                id: `${this.videoID}`,
                byline: false,
                background: this.options.background,
                muted: this.options.muted,
                loop: this.options.loop,
                autoplay: this.options.autoplay
            })

            return this.player.ready()
           
        }

        // callbacks
        play() {
            this.player.play()
        }
        pause() {
            this.player.pause()
        }
        stop() {
            this.player.stop()
        }
        seek(dur) {
            this.player.setCurrentTime(dur)
        }

        // Adding listeners
        addPlayerListeners() {
            this.player.on('play', () => {
                this.playing = true
                this.dispatchEvent(this.events['play'])
            })
            this.player.on('pause', () => {
                this.playing = false
                this.dispatchEvent(this.events['pause'])
            })
            this.player.on('ended', () => {
                this.playing = false
                this.dispatchEvent(this.events['ended'])
            })
        }
    }

    return {
        Player
    }

})()

export default VimeoApi
